import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';

import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPowerOff, faSync, faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { ActivitySessionAttendee } from '@activities/interfaces/activity-session-attendee';
import SendMessageUsingTemplateMixin from '@shared/components/tables/abstract-table/send-message-using-template-mixing';
import ModulesHelper from '@core/services/modules.helper';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import { v4 as uuidv4 } from 'uuid';
import { PosSession } from '@pos/interfaces/pos-session';
import BulkEditModal from '@shared/components/modals/bulk-edit-modal/bulk-edit-modal.vue';
import AuthorizationHelper from '@auth/services/authorization.helper';
import { AccessControlBadge } from '@access-control/interfaces/access-control-badge';
import moment from 'moment/moment';
import BpcAccessControlBadgeForm from '@access-control/components/access-control-badge-form.vue';
import ActivitySessionAttendeeForm from '@activities/components/forms/activity-session-attendee-form/activity-session-attendee-form.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import AddPaymentModal from '@accounting/components/modals/add-payment-modal/add-payment-modal.vue';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';
import ResyncFinddocProductModal from '@access-control/components/modals/resync-finddoc-product-modal/resync-finddoc-product-modal.vue';

library.add(faPowerOff, faToggleOff, faToggleOn, faSync);

@Component({
  name: 'bpc-activity-session-attendee-table',
  components: {
    'bpc-activity-session-attendee-form': ActivitySessionAttendeeForm,
    BpcAccessControlBadgeForm,
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-bulk-recover-modal': BulkRecoverModal,
    'bpc-bulk-edit-modal': BulkEditModal,
    'bpc-custom-filter-selector': CustomFilterSelector,
    'bpc-extended-filter': ExtendedFilter,
    'bc-add-payment-modal': AddPaymentModal,
    'bpc-resync-attendees-modal': ResyncFinddocProductModal,
  },
})
export default class ActivitySessionAttendeeTable extends mixins(
  AbstractTable,
  SendMessageUsingTemplateMixin,
) {
  declare $refs: AbstractTable['$refs'] & {
    stdAttendeeForm: InstanceType<typeof ActivitySessionAttendeeForm> & {
      saveEntity(): void;
      setEntityAttributesAfterSave(): void;
    };
    stdCancelForm: InstanceType<typeof StdForm> & {
      formModel: any;
      formProvider: EntityFormProvider;
    };
  };

  @Prop({ type: String, default: 'cancel-activity-session-attendee' })
  declare readonly cancelFormConfigName: string;
  @Prop(Array) readonly initialFilters: Record<string, any>[];
  @Prop(String) readonly forcedCancelReason: string;
  @Prop(String) readonly forcedCancelReasonDescription: string;
  @Prop(Boolean) readonly profileView: boolean;
  @Prop(Object) readonly externalFormModel: Record<string, any>;
  @Prop({ type: String, default: 'edit' }) readonly editFormConfigName: string;
  @Prop({ type: Array, default: () => ['part1', 'part2'] })
  readonly selectConfigName: string[];
  @Prop({ type: Boolean, default: true }) readonly showTableHeader: boolean;
  @Prop({ type: Boolean, default: true }) readonly withFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly withSearch: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrderBy: boolean;
  @Prop({ type: Boolean, default: true }) readonly showPagination: boolean;
  @Prop({ type: Boolean, default: false }) readonly showTabFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showExtendedFilters: boolean;

  public entity: ActivitySessionAttendee = null;
  public entityName = 'activity-session-attendee';
  public pluralEntityName = 'activity-session-attendees';
  public permissionEntityNameToUse = 'activity_session_attendees';
  public selectedRowEntity = null;

  public isAttendeeActive: boolean = false;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  //DATA
  //Bulk trash modal data
  showBulkMoveToTrashModal = false;
  //Bulk recover modal data
  showBulkRecoverModal = false;
  // Bulk cancel modal data
  public isProcessing: boolean = false;
  public eventsSuccess = [];
  public eventsError = [];
  public requestSent: boolean = false;
  public processAll: boolean = false;
  public reportPerPage: number = 20;
  public reportCurrentPage: number = 1;
  dataToShowInBulkReports = [['code']];
  public pageActionPositions = ['left', 'bulk', 'middle', 'right'];
  // Bulk edit modal
  showBulkEditModal = false;
  bulkEditDataToShow = [['code']];
  extraFieldsToBulkEdit: object = { defaultValueSwitchModel: {} };
  extraDataToBulkEdit: object = {};
  public isCancelingEntity: boolean = false;

  // Add payment modal
  public showPaymentModal: boolean = false;
  // Resync modal data
  showResyncModal: boolean = false;
  isProcessingResync: boolean = false;
  resyncAlertKey: number = 0;

  //Table page actions data
  public customPageActions = {
    resync: {
      activated: false,
      type: 'action',
      icon: 'sync',
      variant: 'primary',
      text: 'resync',
      show: false,
      event: 'resync',
      selectElements: true,
      tag: 'left',
    },
    bulkCancel: {
      activated: false,
      type: 'action',
      icon: 'ban',
      variant: 'danger',
      text: 'cancel',
      event: 'bulk-cancel',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_cancel'],
      show: false,
    },
    bulkSendMessageUsingTemplate: {
      activated: false,
      type: 'action',
      icon: 'envelope', //'times',
      variant: 'info',
      text: 'send_message_using_template',
      show: false,
      event: 'bulk-send-message-using-template',
      selectElements: true,
      tag: 'left',
      permissions: ['show'],
    },
  };
  // Loading state of row actions.
  loadingRowAction: boolean = false;
  // Selected attendee
  selectedAttendee: ActivitySessionAttendee = null;
  // Selected option for update orders
  selectedActionForUpdateOrders: boolean = true;
  // OPtion for update orders
  confirmUpdateOrderOptions: object[] = [
    {
      text: this.$t('global.attendee.orders.cancel.options.update'),
      value: true,
    },
    {
      text: this.$t('global.attendee.orders.cancel.options.no_update'),
      value: false,
    },
  ];

  //Table row actions data
  public customRowActions = {
    continuePayment: {
      activated: false,
      type: 'action',
      icon: 'credit-card',
      show: false,
      event: 'continue-payment',
      text: 'continue-payment',
      permissions: ['pay_attendee'],
    },
    sendMessageUsingTemplate: {
      activated: true,
      type: 'action',
      icon: 'envelope',
      show: true,
      event: 'send-message-using-template',
      text: 'send_message_using_template',
      permissions: ['send'],
    },
  };

  //METHODS

  onResync() {
    this.showResyncModal = true;
    this.$bvModal.show('resync-modal');
  }

  onCloseResyncModal() {
    this.showResyncModal = false;
    this.$refs.provider.getEntities();
  }

  closeResyncProgressBar() {
    if (this.isProcessingResyncEnded) {
      this.$store.dispatch('attendeeResyncStore/closeResyncProccess');
    }
  }

  onStartProcessingResync() {
    this.resyncAlertKey = this.resyncAlertKey + 1;
    this.$store.dispatch('attendeeResyncStore/startResyncProcess');

    this.onCloseResyncModal();
  }

  listenToWebsocketResyncChannel(): void {
    this.$bpcEcho
      .listenResyncAttendeesChannel()
      .listen('.BPC\\Activities\\Events\\AttendeeResyncStarted', data => {
        this.$store.dispatch('attendeeResyncStore/updateResyncStatus', {
          running: true,
          ended: false,
          failed: false,
          totalCount: data.totalCount || 0,
          processedCount: 0,
        });
      })
      .listen('.BPC\\Activities\\Events\\AttendeeResyncProcessed', data => {
        this.$store.dispatch('attendeeResyncStore/updateResyncStatus', {
          running: true,
          ended: false,
          failed: false,
          totalCount: data.totalCount || 0,
          processedCount: data.processedCount || 0,
          isResyncClosed: false,
        });
      })
      .listen('.BPC\\Activities\\Events\\AttendeeResyncEnded', data => {
        this.$store.dispatch('attendeeResyncStore/updateResyncStatus', {
          running: false,
          ended: true,
          failed: false,
          totalCount: data.totalCount || 0,
          processedCount: data.processedCount || 0,
          isResyncClosed: false,
        });
        this.$refs.provider.getEntities();
      });
  }

  leaveWebsocketResyncChannel(): void {
    this.$bpcEcho.leaveResyncAttendesChannel();
  }

  public getActionsByTag(tag: string) {
    const actions = {};
    if (this.pageActions) {
      for (const key of Object.entries(this.pageActions)) {
        if (this.pageActions[key[0]].tag == tag) {
          actions[key[0]] = this.pageActions[key[0]];
        }
      }
    }
    return actions;
  }

  // Bulk soft delete modal (move to trash)
  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }
  onCLoseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }
  onSuccessSoftDelete() {
    this.$emit('entity-deleted');
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
  }

  // Bulk restore modal (recover)
  onBulkRecover() {
    this.showBulkRecoverModal = true;
  }

  onCLoseBulkRecover() {
    this.showBulkRecoverModal = false;
  }

  onSuccessBulkRecover() {
    this.$refs.provider.getEntities();
  }

  getEntities() {
    this.$refs.provider.getEntities();
  }

  onFormSave(next: string = '') {
    this.nextAction = next;
    this.$refs.stdAttendeeForm.saveEntity();
  }

  onFormSaved($event: any = null) {
    this.$emit('entity-saved', $event);
    if (this.nextAction === 'new') {
      this.setEntityAttributesAfterSave();
      this.$refs.provider.getEntities();
    } else if (this.nextAction === 'pay') {
      this.ordersAvailableToPosCheckout = $event.data?.orders;
      this.selectedOrdersToPosCheckout = $event.data?.orders;
      this.selectedContactIdToPosCheckout = $event.data?.contact_id;
      this.selectedPriceCategoryIdToPosCheckout = $event.data?.price_category_id;
      this.selectedInvoiceIdToPosCheckout =
        this.$store.getters['pos/currentTicket']?.status === 'to_pay'
          ? this.$store.getters['pos/currentTicket']
          : null;
      this.onFormClose();
      this.$refs.provider.getEntities();
      this.openExportPosCheckoutModal();
    } else {
      this.onFormClose();
      this.$refs.provider.getEntities();
    }
  }

  // Bulk edit modal
  onBulkEdit() {
    if (!this.emitOnBulkEdit) {
      this.showBulkEditModal = true;
    } else {
      this.$emit('on-bulk-edit', this.selection);
    }
  }
  onCloseBulkEdit() {
    this.showBulkEditModal = false;
  }
  onFinishBulkEdit() {
    this.$refs.provider.getEntities();
  }

  // Page actions
  customOnPageAction($event: string) {
    switch ($event) {
      case 'bulk-cancel':
        this.onOpenBulkCancelModal();
        break;
      case 'bulk-send-message-using-template':
        this.onBulkSendMessageUsingTemplateToAttendees(this.selection);
        break;
      case 'resync':
        this.onResync();
        break;
    }
  }

  extendUpdatePageActions() {
    if (this.config) {
      for (const activatedPageAction of this.config.data.activatedPageActions) {
        if (this.customPageActions[activatedPageAction]) {
          this.customPageActions[activatedPageAction].activated = true;
        }
      }
    }

    this.customPageActions.bulkCancel.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      this.$refs.provider.queryConfig.params.status !== 'cancelled' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed;

    this.customPageActions.bulkSendMessageUsingTemplate.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);

    this.customPageActions.resync.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.isFinddocAccessControlService;
  }

  // Row actions
  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'cancel':
        this.onOpenCancelModal($event.item.item);
        break;
      case 'continue-payment':
        this.$emit('continue-payment', $event.item.item);
        break;
      case 'send-message-using-template':
        this.onSendMessageUsingTemplateToAttendee($event.item.item);
        break;
    }
  }

  extendUpdateRowActions(entity: any) {
    entity.actions.sendMessageUsingTemplate.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);

    entity.actions.cancel.show = entity.can_be_cancelled;
    entity.actions.edit.show = entity.can_be_edited;
    entity.actions.softDelete.show = entity.can_be_trashed;

    entity.actions.continuePayment.show = entity.status === 'requested';
    return null;
  }

  onOpenCancelModal(entity) {
    this.selectedRowEntity = entity;
    this.$bvModal.show('cancel-modal');
  }

  onOpenPaymentModal(entity) {
    this.showPaymentModal = true;
  }

  onCloseAddpaymentModal() {
    this.showPaymentModal = false;
  }
  onPaymentCreated() {
    this.showPaymentModal = false;
    this.$bpcMessage.showSuccessMessage({
      text: 'global.generic.successful_action',
    });
    this.i++; // refresh form
    this.$refs.provider.getEntities(); // refresh table
  }

  onCloseCancelModal() {
    this.selectedRowEntity = null;
    this.isCancelingEntity = false;
    this.$bvModal.hide('cancel-modal');
  }

  onOpenBulkCancelModal() {
    // TODO if only one is selected, call onOpenCancelModal with the selected entity
    this.resetBulkCancelModal();
    this.$bvModal.show('bulk-cancel-modal');
  }

  onCloseBulkCancelModal() {
    this.resetBulkCancelModal();
    this.$bvModal.hide('bulk-cancel-modal');
  }

  resetBulkCancelModal() {
    this.requestSent = false;
    this.isProcessing = false;
    this.eventsSuccess = [];
    this.eventsError = [];
    this.processAll = false;
  }

  onSuccessBulkCancel() {
    this.$refs.provider.getEntities();
  }

  onConfirmCancelOne() {
    this.isCancelingEntity = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-session-attendees');
    const relativePath = '/' + this.selectedRowEntity.id + '/cancel';
    this.$bpcApi
      .post(basePath + relativePath, {
        id: this.selectedRowEntity.id,
        cancel_reason: this.profileView
          ? 'customer'
          : this.$refs.stdCancelForm.formModel['cancel_reason'],
        cancel_reason_description: this.profileView
          ? ''
          : this.$refs.stdCancelForm.formModel['cancel_reason_description'],
        cancel_orders: this.profileView
          ? true
          : this.$refs.stdCancelForm.formModel['cancel_orders'],
        notify_by_email:
          'notify_by_email' in this.$refs.stdCancelForm.formModel
            ? this.$refs.stdCancelForm.formModel['notify_by_email']
            : true,
      })
      .subscribe(
        res => {
          this.$bpcMessage.showSuccessMessage({
            text: 'global.generic.successful_action',
          });
          this.$refs.provider.getEntities();
        },
        error => {
          this.$bpcMessage.showErrorMessage({
            text: 'global.generic.error_form_action',
          });
        },
        () => {
          this.$bvModal.hide('cancel-modal');
          this.selectedRowEntity = null;
          this.isCancelingEntity = false;
          this.onFormClose();
        },
      );
  }

  onConfirmCancelBulk() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-session-attendees');
    const relativePath = '/bulk-cancel';
    const sessionCode = this.generateSessionCode();
    this.listenToWebsocketCancelChannel(sessionCode);
    this.requestSent = true;

    this.$bpcApi
      .post(basePath + relativePath, {
        ids: this.selection,
        filters: this.filterModel,
        search_and_order: this.searchAndOrderQueryParams,
        process_all: this.processAll,
        session_code: sessionCode,
        cancel_reason: this.$refs.stdCancelForm.formModel['cancel_reason'],
        cancel_reason_description: this.$refs.stdCancelForm.formModel['cancel_reason_description'],
        cancel_orders: this.$refs.stdCancelForm.formModel['cancel_orders'],
        notify_by_email:
          'notify_by_email' in this.$refs.stdCancelForm.formModel
            ? this.$refs.stdCancelForm.formModel['notify_by_email']
            : true,
        // ...this.extraData,
      })
      .subscribe(
        res => {
          // this.$emit('request-sent');
        },
        error => {
          // this.$emit('error-sending-request');
          console.log(error);
          this.$bpcMessage.showErrorMessage({
            text: 'global.generic.error_form_action',
          });
          this.$bpcEcho.leaveBulkCancelChannel(sessionCode);
          this.resetBulkCancelModal();
        },
      );
  }

  listenToWebsocketCancelChannel(sessionCode) {
    this.isProcessing = true;
    this.$bpcEcho
      .listenBulkCancelChannel(sessionCode)
      .listen('.BPC\\Core\\Events\\EntitiesCancelled', data => {
        if (data.result?.entities_processed?.length) {
          this.$bpcMessage.showInfoMessage({
            text: 'global.actions.bulk_cancel.entities_cancelled',
          });
        }
        this.isProcessing = false;
        this.onSuccessBulkCancel();
        this.$bpcEcho.leaveBulkCancelChannel(sessionCode);
      })
      .listen('.BPC\\Core\\Events\\EntityCancelled', data => {
        this.eventsSuccess.push(data);
      })
      .listen('.BPC\\Core\\Events\\ErrorCancellingEntity', data => {
        this.eventsError.push(data);
      });
  }

  generateSessionCode(): string {
    return `cancel-${this.tenantId}-${uuidv4()}`;
  }

  onModelLoaded() {
    this.isAttendeeActive = this.$refs.stdAttendeeForm.formModel.status === 'active';
    const formModel = this.$refs.stdAttendeeForm.formModel;
    const newModel = {
      ...formModel,
      is_attendee_active: this.isAttendeeActive,
    };
    this.$set(this.$refs.stdAttendeeForm, 'formModel', newModel);
  }

  //COMPUTED

  get resyncAlertStatus(): string {
    if (this.isProcessingResyncRunning) {
      return 'warning';
    } else if (this.isProcessingResyncEnded) {
      return 'success';
    } else if (this.isProcessingResyncFailed) {
      return 'danger';
    } else {
      return 'info';
    }
  }
  // Access control badge
  get hasAccessControlModuleActivated() {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ACCESS_CONTROL_MODULE_NAME);
  }

  get canCreateAccessControlBadges() {
    const permissionName = AuthorizationHelper.getPermissionName('store', 'access_control_badges');
    return this.$authorizationService.hasPermissions([permissionName]);
  }
  get selectedRowEntityId() {
    return this.entity?.id;
  }
  get initialAccessControlBadgeData(): Partial<AccessControlBadge> {
    return {
      status: 'active',
      contact_id: Number(this.entity?.attendee_id),
      type: 'rfid',
    };
  }
  isSavingAccessControlBadge: boolean = false;
  labelSaveAccessControlBadgeButton: string =
    'global.access_control_badge.label_to_add_from_contact';
  timestamp = moment().unix();
  get accessControlBadgeFormCancelPortalTarget() {
    return `access-control-badge-form-cancel-action-${this.timestamp}`;
  }

  get accessControlBadgeFormSavePortalTarget() {
    return `access-control-badge-form-actions-${this.timestamp}`;
  }

  get titleAddAccessControlBadgeModal(): string {
    return (
      this.$t('global.modals.create') + ' ' + this.$t('global.models.access-control-badge.name')
    );
  }
  onClickCreateAccessControlBadge() {
    this.$bvModal.show('modal-add-access-control-badge');
  }

  onCloseAccessControlBadgeModal() {
    this.$bvModal.hide('modal-add-access-control-badge');
  }
  onSavedAccessControlBadge($event) {
    this.$root.$emit('new-badge-created-from-attendee', $event.data);
  }

  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get pageActions() {
    // Invert the order
    return {
      ...this.customPageActions,
      ...this.defaultPageActions,
    };
  }

  get reportRows() {
    return this.eventsError.length;
  }
  get reportCurrentList() {
    const start = this.reportCurrentPage * this.reportPerPage - this.reportPerPage;
    const end = start + this.reportPerPage;
    return this.eventsError.slice(start, end);
  }

  actionAfterPrepareToSave(entity: any): AnyEntity {
    if (!entity.id && this.formConfigName === 'default-for-clubs') {
      entity.activity_group_id = entity.activityGroup;
    }
    if (!entity.id && this.formConfigName === 'create-club-from-session') {
      entity.activity_group_id = this.externalFormModel.activity_group_id;
      entity.activity_id = this.externalFormModel.id;
      entity.activity_session_id = this.externalFormModel.activity_session_id;
    }
    if (
      entity.id &&
      (this.editFormConfigName === 'edit-for-clubs' ||
        this.editFormConfigName === 'edit-competition-attendee-for-clubs')
    ) {
      entity.activity_group_id = entity.activityGroup?.id;
    }

    return entity;
  }

  get openPosSessionId(): PosSession {
    return this.$store.getters['pos/openPosSessionId'];
  }

  onFormClickToPay() {
    this.ordersAvailableToPosCheckout = this.entity?.orders;
    this.selectedOrdersToPosCheckout = this.entity?.orders;
    this.selectedContactIdToPosCheckout = this.entity?.attendee_id;
    this.selectedPriceCategoryIdToPosCheckout = this.entity?.attendee?.price_category_id;
    this.selectedInvoiceIdToPosCheckout =
      this.$store.getters['pos/currentTicket']?.status === 'to_pay'
        ? this.$store.getters['pos/currentTicket']
        : null;
    this.openExportPosCheckoutModal();
  }

  get availableToPosCheckout(): boolean {
    return (
      this.$authorizationService.hasPermissionForAction('pos_sessions', 'pos_checkout', true) &&
      this.$store.getters['pos/openPosSession'] &&
      this.entity?.orders &&
      this.entity?.orders.some(
        order => order.status === 'waiting' || order.status === 'shopping_cart',
      )
    );
  }

  get availableToAddPayment(): boolean {
    return (
      this.entity?.orders &&
      this.entity?.orders.some(
        order =>
          order.status === 'waiting' ||
          order.status === 'shopping_cart' ||
          order.status === 'invoiced' ||
          order.status === 'payment_process',
      )
    );
  }

  get hasPermissionToCancel(): boolean {
    return this.$authorizationService.hasPermissionForAction(
      this.permissionEntityNameToUse,
      'cancel',
    );
  }

  get accessControlConfig(): AccessControlConfigInterface {
    return this.$store.getters['centerSettings/accessControlConfig'];
  }

  get isInternalAccessControlService(): boolean {
    return this.accessControlConfig?.access_control_service === 'internal';
  }

  get isFinddocAccessControlService(): boolean {
    return this.accessControlConfig?.access_control_service === 'finddoc';
  }

  get isProcessingResyncFailed(): boolean {
    return this.$store.getters['attendeeResyncStore/isProcessingResyncFailed'];
  }
  get isProcessingResyncEnded(): boolean {
    return this.$store.getters['attendeeResyncStore/isProcessingResyncEnded'];
  }
  get totalCount(): number {
    return this.$store.getters['attendeeResyncStore/totalCount'];
  }
  get processedCount(): number {
    return this.$store.getters['attendeeResyncStore/processedCount'];
  }
  get isProcessingResyncRunning(): boolean {
    return this.$store.getters['attendeeResyncStore/isProcessingResyncRunning'];
  }
  get isResyncClosed(): boolean {
    return this.$store.getters['attendeeResyncStore/isResyncClosed'];
  }

  /* Lifecycle hooks */

  // created() {}
  mounted() {
    this.$root.$on('refresh-table-after-add-orders-to-pos', () => {
      this.refreshEntitiesAfterOrdersAddedToPosCheckout();
    });

    if (this.isFinddocAccessControlService) {
      this.listenToWebsocketResyncChannel();
    }
  }
  // updated() {}
  destroyed() {
    this.$root.$off('refresh-table-after-add-orders-to-pos');
    if (this.isFinddocAccessControlService) {
      if (!this.isProcessingResyncRunning) {
        this.leaveWebsocketResyncChannel();
      }
    }
  }
}
